import React from 'react';

import { EditComponentProps } from '@/types/editComponentProps';

export interface ContactDetailsSectionBaseEntry {
  readonly key: string;
  readonly displayValue: string;
}

export interface ContactDetailsSectionDisplayableEntry extends ContactDetailsSectionBaseEntry {
  readonly label?: string;
}

export interface ContactDetailsSectionEditableEntry extends ContactDetailsSectionBaseEntry {
  readonly label: string;
  readonly value: string;
  readonly editable: true;
  readonly inputComponent: React.FunctionComponent<EditComponentProps>;

  updateHandler(value: string): Promise<void>;
  validateHandler?(value: string): Promise<string | null>;
}

export type ContactDetailsSectionEntry =
  | ContactDetailsSectionDisplayableEntry
  | ContactDetailsSectionEditableEntry;

export interface ContactDetailsSectionData {
  readonly key: string;
  readonly title: string;
  readonly values: ReadonlyArray<
    ContactDetailsSectionDisplayableEntry | ContactDetailsSectionEditableEntry
  >;
}

export const isContactDetailsSectionEditableEntry = (
  entry: ContactDetailsSectionEntry,
): entry is ContactDetailsSectionEditableEntry => {
  return 'editable' in entry && entry.editable && 'value' in entry && 'inputComponent' in entry;
};
